import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { NoItemPlaceholderModule } from '@portal-core/general/components/no-item-placeholder/no-item-placeholder.module';
import { ProjectChecklistBarChartModule } from '@portal-core/project-checklists/components/project-checklist-bar-chart/project-checklist-bar-chart.module';
import { ProjectChecklistColumnMenuModule } from '@portal-core/project-checklists/components/project-checklist-column-menu/project-checklist-column-menu.module';
import { ProjectChecklistDoughnutChartModule } from '@portal-core/project-checklists/components/project-checklist-doughnut-chart/project-checklist-doughnut-chart.module';
import { ProjectChecklistTableModule } from '@portal-core/project-checklists/components/project-checklist-table/project-checklist-table.module';
import { ProjectChecklistOverviewComponent } from './project-checklist-overview.component';

@NgModule({
  declarations: [
    ProjectChecklistOverviewComponent
  ],
  imports: [
    CommonModule,
    ProjectChecklistDoughnutChartModule,
    ProjectChecklistBarChartModule,
    ProjectChecklistTableModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    NoItemPlaceholderModule,
    ProjectChecklistColumnMenuModule
  ],
  exports: [
    ProjectChecklistOverviewComponent
  ]
})
export class ProjectChecklistOverviewModule { }
